import { useEffect, useState } from "react";
import axios from "axios";
import { GraduationCap, MapPin, FileText, Presentation, PlayCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function fmtDate(iso) {
  if (!iso) return "Data por marcar";
  try { return new Date(iso + "T00:00:00").toLocaleDateString("pt-PT", { weekday: "short", day: "2-digit", month: "short", year: "numeric" }); }
  catch { return iso; }
}

// Painel "As minhas sessões como educador" — só aparece quando o sócio
// é educador de pelo menos uma sessão futura.
export const EducatorSessionsPanel = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/members/itineraries/educator-sessions`, { withCredentials: true })
      .then((r) => setItems(r.data.items || []))
      .catch((e) => console.warn("[EducatorSessions] load failed:", e?.message));
  }, []);

  if (!items.length) return null;

  return (
    <div className="mt-8 bg-white border-l-4 border-[hsl(var(--accent))] border border-[hsl(var(--border))] p-6" data-testid="educator-sessions-panel">
      <div className="flex items-center gap-2">
        <GraduationCap className="h-5 w-5 text-[hsl(var(--accent))]" />
        <span className="text-[11px] uppercase tracking-[0.22em] text-[hsl(var(--muted-foreground))]">
          As minhas sessões como educador
        </span>
      </div>
      <ul className="mt-4 space-y-3">
        {items.map((s) => (
          <li key={`${s.edition_id}-${s.index}`} className="text-sm border-b border-[hsl(var(--border))] last:border-0 pb-3 last:pb-0"
            data-testid={`educator-session-${s.edition_id}-${s.index}`}>
            <div className="font-medium">
              Sessão {s.index} — {s.title}
              <span className="text-xs text-[hsl(var(--muted-foreground))] font-normal"> · {s.itinerary_title} ({s.edition_title})</span>
            </div>
            <div className="text-xs text-[hsl(var(--muted-foreground))] mt-1">
              {fmtDate(s.date)}{s.time ? ` às ${s.time}` : ""}
              {s.location && <span> · <MapPin className="inline h-3 w-3" /> {s.location}</span>}
              {" "}· {s.participant_count} participante(s)
            </div>
            <div className="mt-1.5 flex flex-wrap gap-x-4 gap-y-1">
              {s.ppt_url && (
                <a href={s.ppt_url} target="_blank" rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 text-[11px] uppercase tracking-[0.16em] text-[hsl(var(--accent))] hover:text-[hsl(var(--primary))]"
                  data-testid={`educator-ppt-${s.edition_id}-${s.index}`}>
                  <Presentation className="h-3 w-3" /> {s.ppt_name || "PowerPoint da sessão"}
                </a>
              )}
              {s.doc_url && (
                <a href={s.doc_url} target="_blank" rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 text-[11px] uppercase tracking-[0.16em] text-[hsl(var(--primary))] hover:text-[hsl(var(--accent))]">
                  <FileText className="h-3 w-3" /> {s.doc_name || "Módulo (PDF)"}
                </a>
              )}
              {s.video_url && (
                <a href={s.video_url} target="_blank" rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 text-[11px] uppercase tracking-[0.16em] text-[hsl(var(--primary))] hover:text-[hsl(var(--accent))]">
                  <PlayCircle className="h-3 w-3" /> Vídeo de preparação
                </a>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
